(function Module() {
	'use strict';

	mySynch.controller('FarmDetailsController', [
		'$scope',
		'$timeout',
		'ViewAuthorizationFactory',
		'mySynchEnumerationService',
		function FarmDetailsController($s, $timeout, viewAuth,mySynchEnumSvc) {
			$s.hasRolePermission = function hasRolePermission(permission) {
				return viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumerationName("Permission",permission));
			};
			$s.checkHerdSofwarePermission = function checkHerdSofwarePermission(allowedHerdSoftware){
				return viewAuth.hasHerdSoftwarePermission(allowedHerdSoftware);
			};

			$s.canUpdate = function canUpdate() {
				return $s.hasRolePermission('FARM_DEMOGRAPHICS_UPDATE');
			};
			
			$s.refresh = function onRefresh(){
				var demographicsTab = $s.tabsetCtrl.tabs[0];

			    if (!demographicsTab.selected) {
				  $timeout(function inATic() {
						demographicsTab.select();
					});
				}
			};
			
		
			$s.$on('herd:changed', function onHerdChanged() {
				
			  $s.refresh();
			});
		}
	]);
})();
